import { ComparisonFlagsType } from '@/utils/constants';

export function hasComparisonFlag(comparison: { flags?: string[] }, flag: ComparisonFlagsType): boolean {
  return Array.isArray(comparison.flags) && comparison.flags.includes(flag);
}
